/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "4dc5e608438fb67068a50f8876d841a30d6426c6";
